import React, { ReactNode } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  modalClass?: string;
  closeButton?: boolean;
};

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  modalClass,
  closeButton = true,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      style={{ zIndex: 1030 }}
    >
      <div className={modalClass}>
        {/* Close Button */}
        {closeButton && (
          <button
            onClick={onClose}
            style={{ top: "-8px", right: "-8px" }}
            className="absolute text-gray-200 text-sm p-2 z-10 rounded-full hover:bg-gray-400 bg-gray-100 modalCloseBtn"
          >
            <XMarkIcon className="w-5 h-5 text-gray-900 text-lg" />
          </button>
        )}
        {/* Modal Content */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
